import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/store';

const getVisualTestingState = (state: RootState) => state.visualTesting;

export const getTestResults = (prId: string) => (state: RootState) =>
  getVisualTestingState(state).results[prId];

export const getTestResultsSelector = (prId: string) =>
  createSelector(getVisualTestingState, (state) => state.results[prId]);

export const getLoading = (state: RootState) =>
  getVisualTestingState(state).loading;

export const getError = (state: RootState) =>
  getVisualTestingState(state).error;
